import { useSelector } from 'react-redux';

import { DefaultAvatar } from 'atoms/default-avatar';

export function UserAvatarExtraSmall() {
  const { selectedGroomer } = useSelector((state) => state.ui);
  if (selectedGroomer.isLocation) return;
  return (
    <DefaultAvatar
      size="extra-small"
      avatar={selectedGroomer.links?.image?.desktop?.small}
      className="mr-10"
    />
  );
}

export function UserAvatarSmall() {
  const { selectedGroomer } = useSelector((state) => state.ui);
  if (selectedGroomer.isLocation) return;
  return (
    <DefaultAvatar
      size="small"
      avatar={selectedGroomer.links?.image?.desktop?.small}
      className="mr-10"
    />
  );
}
